export const dateControlOptions = [
  { title: '30 Days', value: 30 },
  { title: '90 Days', value: 90 },
  { title: 'Year', value: 365 },
];
